import { syncHistoryWithStore, routerReducer } from 'react-router-redux'
import { combineReducers } from 'redux';
import navReducer from './nav-reducer';
import gameReducer from './game-reducer';
import userReducer from './user-reducer';
import routingReducer from './routing-reducer';
import teamReducer from './team-reducer';
import modalReducer from './modal-reducer';
import leaderReducer from './leader-reducer';
import eventsReducer from './event-reducer';
import appReducer from './app-reducer';

// Root Reducer
const rootReducer = combineReducers({
  routing: routerReducer,
  // routing: routingReducer,
  leaders: leaderReducer,
  events: eventsReducer,
  modal: modalReducer,
  teams: teamReducer,
  game: gameReducer,
  user: userReducer,
  app: appReducer,
  nav: navReducer,
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js